import { DEFAULT_ZONE_SLUG } from 'consts'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { RoleModel } from 'utils/role'
import { LinkRow } from 'views/common/link-row'

const Wrapper = styled.div`
  padding-bottom: 48px;
`

interface Props {
  categories: any[]
  role: RoleModel
}

export const CategoriesMobile: ComponentType<Props> = ({ categories, role }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          {categories.map((category) => (
            <LinkRow
              key={category.uuid}
              href="/[categorySlug]/[roleSlug]/[zoneSlug]"
              as={`/${category.slug}/${role.slug}/${DEFAULT_ZONE_SLUG}`}
              title={category.pluralName}
              subtitle={`${category.properties} propiedades`}
              image={category.cover?.thumbnailUrl}
            />
          ))}
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
